import Select from "react-select";
import { FormattedMessage } from "react-intl";
import { Button, ExclamationCircleIcon, Flex, Text } from "@paguelofacil/pf-components";
import { useState } from "react";
import { toast } from "react-toastify";

import useStore from "../../services/store/useStore";
import { language, languageDefault } from "../../services/utils/Language";
import { REGEX_ONLY_LETTER, STEPS_CRYPTO_PAYMENT } from "../../services/utils/Constants";
import { ManageService } from "../../services/Services";
import { useGetCryptoCoins } from "../../hooks/useGetCryptoCoins";

import { Option, NoOptionsMessage } from "../Inputs/Select-Options";
import { SelectWithImage } from "../Inputs/SelectWithImage";

const CoinAndNetworkForm = ({ isLoading, setCurrentStep, onResetTimer }) => {
    const { setCurrencySelected, setNetworkSelected, setNetworks, networkSelected, currencySelected, coins, networks } =
        useStore(state => state);

    const { isLoadingCoins } = useGetCryptoCoins("ZINLI");
    const [valueInput, setValueInput] = useState();
    const [isLoadingNetwork, setIsLoadingNetwork] = useState(false);

    const onChangeSelectCurrency = valueCurrency => {
        setNetworkSelected(null);
        setNetworks(null);
        setIsLoadingNetwork(true);
        setCurrencySelected(valueCurrency);

        ManageService.getCryptoNetworks("ZINLI", valueCurrency.value)
            .then(resp => {
                if (resp && resp.length) {
                    setNetworks(resp);
                }
            })
            .catch(error => {
                console.log("error al intentar obtener las redes crypto disponibles segun currency seleccionada");
                toast.error(error.message);
            })
            .finally(() => setIsLoadingNetwork(false));

        //reseteamos el tiempo cuando cambiamos la moneda
        if (onResetTimer) onResetTimer();
    };

    const onChangeSelectNetwork = valueNetwork => {
        setNetworkSelected(valueNetwork);
    };

    const onChangeInput = (value, actionMeta) => {
        if (value && !REGEX_ONLY_LETTER.test(value)) {
            setValueInput(actionMeta.prevInputValue);
        } else {
            setValueInput(undefined);
        }
    };

    const isInvalidForm = !networkSelected || !currencySelected;

    return (
        <>
            <Flex direction="column" justify="flex-start" align="flex-start" gap="0.25rem">
                <label className="title-info-payment-2">
                    <FormattedMessage id={language.coin} defaultMessage={languageDefault.coin} />
                    <span style={{ color: "#e11900" }}>&nbsp;*</span>
                </label>
                <SelectWithImage
                    objectOptions={coins || []}
                    id="select-currency"
                    onChange={onChangeSelectCurrency}
                    placeholder={isLoadingCoins ? "loading..." : "Seleccionar"}
                    isLoading={isLoadingCoins}
                    value={currencySelected}
                />
            </Flex>
            <Flex direction="column" justify="flex-start" align="flex-start" gap="0.25rem">
                <label className="title-info-payment-2">
                    <FormattedMessage id={language.network} defaultMessage={languageDefault.network} />
                    <span style={{ color: "#e11900" }}>&nbsp;*</span>
                </label>
                <Select
                    className="select-options"
                    placeholder={isLoading || isLoadingNetwork ? "loading..." : "Seleccionar"}
                    id="select-network"
                    options={networks || []}
                    onChange={value => onChangeSelectNetwork(value, false)}
                    value={networkSelected}
                    onInputChange={onChangeInput}
                    inputValue={valueInput}
                    isLoading={isLoadingNetwork}
                    components={{
                        Option,
                        NoOptionsMessage,
                    }}
                />
                <Text className="message-sub" variant="caption" weight="regular">
                    <ExclamationCircleIcon color="#EDB600" size="12" isFullfill />{" "}
                    <FormattedMessage
                        id={language.information_crypto_1}
                        defaultMessage={languageDefault.information_crypto_1}
                    />{" "}
                </Text>
            </Flex>
            {setCurrentStep ? (
                <Button
                    className="button-primary-cf"
                    fullWidth
                    variant="primary"
                    size="md"
                    disabled={isInvalidForm || isLoading || isLoadingNetwork || isLoadingCoins}
                    handleClick={() =>
                        setCurrentStep({
                            ref: STEPS_CRYPTO_PAYMENT.DETAILS_PAYMENT,
                            data: { networkSelected, currencySelected },
                        })
                    }
                >
                    <FormattedMessage id={language.next} defaultMessage={languageDefault.next} />
                </Button>
            ) : (
                <></>
            )}
        </>
    );
};

export default CoinAndNetworkForm;
